import dayjs from "dayjs";

export function formatJst(dateStr) {
  if (!dateStr) return "-";
  return dayjs(dateStr).format("YYYY-MM-DD HH:mm");
}

export function formatDate(dateStr) {
  if (!dateStr) return "-";
  return dayjs(dateStr).format("YYYY-MM-DD");
}
